import { toast } from 'react-toastify';

export const TOAST_NOTIFY_TYPES = {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
    DEFAULT: 'default'
};

class ToastifyService {
    constructor() {
        this.toastConfig = {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark'
        };
        this.toastCb = {
            success: toast.success,
            info: toast.info,
            warning: toast.warn,
            error: toast.error,
            default: toast
        };
    }

    setToast(message, toastType, customConfig = {}) {
        this.toastCb[toastType](message, { ...this.toastConfig, ...customConfig });
    }
}

export default new ToastifyService();
